module.exports = __webpack_public_path__ + "img/view.939adbab.png";